import "@interopio/fdc3";
import glueFactory from "@interopio/desktop";
import { AsyncConstructors } from "./common/windowFunctions";
import { PromiseWrapper } from "./utils/pw";
import { Router } from "./router/router";
import { LoggerImpl } from "./logger/index";
let FreestandingGlobals = window;
const startAdapter = async (application, ws, username, password) => {
    console.log(`Starting finsemble js adapter for iocd with name ${application} connecting to ${ws}.`);
    const pw = new PromiseWrapper();
    const pw2 = new PromiseWrapper();
    const glueConfig = {
        gateway: {
            protocolVersion: 3,
            ws
        },
        auth: {
            username,
            password
        },
        application,
        bus: true,
        windows: true,
        appManager: "full",
        channels: true,
    };
    const glue = glueFactory(glueConfig);
    const asyncConstructors = new AsyncConstructors();
    const Logger = new LoggerImpl(glue, asyncConstructors);
    const RouterClient = new Router(glue, asyncConstructors, Logger);
    FreestandingGlobals.FSBL = {
        Clients: {
            RouterClient
        }
    };
    glue.then((g) => {
        FreestandingGlobals.iop = FreestandingGlobals.iop ?? g;
        pw.resolve();
    });
    console.log("Waiting for iocd library initialization.");
    await pw.promise;
    console.log("iocd library initialized. Waiting for js adapter.");
    await Promise.all([asyncConstructors.ready()]);
    console.log("js adapter for iocd initialized. Waiting for fdc3.");
    if (!FreestandingGlobals.fdc3) {
        window.addEventListener('fdc3Ready', () => {
            pw2.resolve();
        });
        await pw2.promise;
    }
    console.log("fdc3 is ready.");
};
const main = () => {
    FreestandingGlobals.FSBLJSAdapter = {
        startApp: async (params) => {
            const ws = params.routerAddress ?? "ws://localhost:8385/";
            const appId = params.appId ?? params.appName ?? "finsemble-javascript-adapter";
            startAdapter(appId, ws, params.username ?? "j9T$mL7Q#vP2xZfR@eK5bN8hW3dA", params.password ?? "j9T$mL7Q#vP2xZfR@eK5bN8hW3dA");
        }
    };
};
main();
